// extracted by mini-css-extract-plugin
export default {"btn":"BackButton_btn__ZJ4Xt","icon":"BackButton_icon__7ZM-A","text":"BackButton_text__Vrpkr","v_ghost":"BackButton_v_ghost__BurKi","v_icon":"BackButton_v_icon__ty0C2"};